import * as Yup from 'yup';

const editReplyValidationSchema = Yup.object().shape({
  text: Yup.string().required('Please enter your reply')
});

export default editReplyValidationSchema;
